import { Inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Settings } from '../models/common.model';
import { DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  script = document.createElement('script');


  constructor(
    private http: HttpClient,
    @Inject(DOCUMENT) private _document: HTMLDocument,
    private commonService: CommonService,
    private titleService: Title
  ) {}

  async setUpGoogleScript(): Promise<void> {
    setTimeout(() => {
      // Set Google Api keY DYNAMICALLY
      const head = document.getElementsByTagName('body')[0];

      if (!document.getElementById('testScriptName')) {
        this.script.type = 'text/javascript';
        this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
        this.script.id = 'newTestScriptName';
        this.script.async = true;
        head.appendChild(this.script);
      }
    }, 100);
  }

  api: any;
  projectSettings:any;


  async load(): Promise<void> {
    this.setData();
    this.api = `${environment.base_url}admin/settings`;
    await this.getGreatSettings();
  }

  async getGreatSettings(): Promise<void> {
    const res = await this.http.get<{data: Settings}>(this.api).toPromise();
    if (res?.data) {
      this.commonService.settingsSubject.next(res.data);
      this.projectSettings = res.data;
      this.setData();
    }
  }

  setData(): void {
    localStorage.setItem('webSettings', JSON.stringify(this.projectSettings));
    setTimeout(() => {
      if (this.projectSettings && this.projectSettings.colorCodes) {

        document.documentElement.style.setProperty(
          '--c_primary',
          this.projectSettings.colorCodes
        );
      }

      if (this.projectSettings?.buttonPrimary) {
        document.documentElement.style.setProperty('--c_secondary', this.projectSettings.buttonPrimary);
      }

      // Set button primary color and button text color

      if (this.projectSettings?.theme) {
        document.documentElement.style.setProperty('--c_primary', this.projectSettings.theme);
      }

      if (this.projectSettings?.buttonTextColor) {
        document.documentElement.style.setProperty('--c_secondary_txt', this.projectSettings.buttonTextColor);
      }

      // Set Favicon
      if (this.projectSettings?.favIcon) {
        const faviconElement = this._document.getElementById('appFavicon');
        if (faviconElement) {
          faviconElement.setAttribute('href', this.projectSettings.favIcon);
        }
      }

      // Set Title
      if (this.projectSettings && this.projectSettings.appName) {
        this.titleService.setTitle(`${this.projectSettings.appName}`);
      }

      // Set app logo and web logo
      if (this.projectSettings?.appLogo) {
        const appLogoElement = this._document.getElementById('appLogo');
        if (appLogoElement) {
          appLogoElement.setAttribute('src', this.projectSettings.appLogo);
        }
      }

      if (this.projectSettings?.webLogo) {
        const webLogoElement = this._document.getElementById('webLogo');
        if (webLogoElement) {
          webLogoElement.setAttribute('src', this.projectSettings.webLogo);
        }
      }
    }, 1000);
  }

}
